import { useMemo } from 'react';

import { Subscription } from 'app-types';
import { UserRole } from 'app-types/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { useUserProfile } from '../hooks/core/user/useUserProfile';

dayjs.extend(utc);

const useGetDeskInfo = (subscription?: Subscription) => {
  const { data: userProfile } = useUserProfile();

  const hasActivatedDesk = useMemo(
    () =>
      !!subscription?.isActive &&
      !!subscription?.addons?.some(
        (addon) =>
          addon.type === 'desk' && (dayjs.utc(addon.expiredOn).isAfter() || !addon.expiredOn),
      ),
    [subscription],
  );

  const isCanceling = useMemo(
    () =>
      !!subscription?.isActive &&
      !!subscription?.addons?.some((addon) => addon.type === 'desk' && !!addon.expiredOn),
    [subscription],
  );

  const hasAccessToDesk = useMemo(() => {
    const isWarehouseWithoutDesk =
      userProfile?.roles?.includes(UserRole.Warehouse) &&
      !userProfile?.roles?.includes(UserRole.CustomerSupport);

    const isWarehouseWithDesk =
      userProfile?.roles?.includes(UserRole.Warehouse) &&
      userProfile?.roles?.includes(UserRole.CustomerSupport);

    return (
      (hasActivatedDesk && !isWarehouseWithoutDesk) || (hasActivatedDesk && isWarehouseWithDesk)
    );
  }, [hasActivatedDesk, isCanceling]);

  return { hasActivatedDesk, isCanceling, hasAccessToDesk };
};

export { useGetDeskInfo };
